import React, { useEffect, useState } from 'react';
import { Button } from './ui';
import { Clock } from 'lucide-react';
import { trackInitiateCheckout } from './useMetaPixel';
const CHECKOUT_URL = 'https://conduca-infantil.impultienda.ar/checkout';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 52
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const remainingRatio = (timeLeft.h * 3600 + timeLeft.m * 60 + timeLeft.s) / 86400;
  return <>
      {/* Urgency band — full width */}
      <section className="w-full bg-[#280000] px-4 py-14 md:py-20" data-id="element-135" data-mp="1k1n9sv2mc21m">
        <div className="max-w-3xl mx-auto" data-id="element-136" data-mp="1f2abne6ar8jq">
          <p className="flex items-center justify-center gap-2.5 text-center text-white font-black tracking-tight text-xl sm:text-3xl" data-id="element-137" data-mp="1f18xh0tzi5xs">
            <Clock className="w-6 h-6 sm:w-8 sm:h-8 shrink-0 text-red-500 animate-pulse" data-id="element-138" data-mp="1a5a6r6l6obu7" />
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </p>

          <div className="mt-8 flex items-start justify-center gap-3 sm:gap-8" data-id="element-139" data-mp="22s4ohvqm8x3z">
            {[{
            value: timeLeft.h,
            label: 'HS'
          }, {
            value: timeLeft.m,
            label: 'MIN'
          }, {
            value: timeLeft.s,
            label: 'SEG'
          }].map((unit, i) => <React.Fragment key={unit.label} data-id="element-140" data-mp="2ljxhhq5oqibp" data-mpi={i}>
                {i > 0 && <span className="text-red-900 font-black text-5xl sm:text-8xl leading-none" aria-hidden="true" data-id="element-141" data-mp="2gql4kdadbzys">
                    :
                  </span>}
                <div className="text-center" data-id="element-142" data-mp="jv9qcig5wytx">
                  <p className="tabular-nums font-black text-red-600 text-6xl sm:text-8xl leading-none" data-id="element-143" data-mp="54smytjyvyue">
                    {String(unit.value).padStart(2, '0')}
                  </p>
                  <p className="mt-3 text-[11px] sm:text-sm font-semibold tracking-[0.3em] text-red-100/50" data-id="element-144" data-mp="3s98j7b7u8437">
                    {unit.label}
                  </p>
                </div>
              </React.Fragment>)}
          </div>

          <p className="mt-9 text-center text-base sm:text-lg text-white" data-id="element-145" data-mp="3icdnf02y8hsm">
            ⚠️ Después vuelve a{' '}
            <span className="font-black text-red-500" data-id="element-146" data-mp="3na5p2ltebia0">USD 49.99</span>. No
            vuelve.
          </p>

          <div className="mt-9" data-id="element-147" data-mp="1ghd12a8t9dy7">
            <div className="flex items-center justify-between text-sm" data-id="element-148" data-mp="1lial6sddsi2c">
              <span className="text-red-50/80 font-medium" data-id="element-149" data-mp="1lg6haafhfj22">
                🔴 Precio de lanzamiento
              </span>
              <span className="text-red-400 font-bold" data-id="element-150" data-mp="311ql5hwzyhje">Por tiempo limitado</span>
            </div>
            <div className="w-full mt-3 bg-slate-800/80 rounded-full h-3 overflow-hidden" data-id="element-151" data-mp="3fq4lnm6xxtws">
              <div className="h-full rounded-full bg-gradient-to-r from-red-600 to-orange-500 transition-[width] duration-1000 ease-linear" style={{
              width: `${Math.max(2, remainingRatio * 100)}%`
            }} data-id="element-152" data-mp="3azo88234e8af"></div>
            </div>
            <p className="text-xs text-red-100/50 mt-3 text-center" data-id="element-153" data-mp="2jkzdt09udki">
              Al terminar el contador el Kit vuelve a USD 49.99.
            </p>
          </div>
        </div>
      </section>

      <section className="py-14 px-3 sm:px-4 bg-teal-50 border-b-2 border-teal-200 relative" id="planes" data-id="element-154" data-mp="24b7vg8z0synu">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-teal-500/15 via-teal-50 to-teal-50 pointer-events-none" data-id="element-155" data-mp="1zcwgjjtvbxyr"></div>

        <div className="max-w-5xl mx-auto relative z-10" data-id="element-156" data-mp="ve0zmvynclle">
          <h2 className="text-2xl md:text-4xl font-bold text-center text-navy mb-7" data-id="element-157" data-mp="vcg4p58f70n0">
          DEJÁ DE IMPROVISAR EN LOS
          <br data-id="element-158" data-mp="10bjawt04zcwk" />
          MOMENTOS DIFÍCILES
        </h2>

        {/* Plan selector */}
        <div className="flex flex-col gap-3 max-w-2xl mx-auto" role="radiogroup" aria-label="Elegí tu Kit" data-id="element-159" data-mp="14cv1b0qu425t">
          <button type="button" role="radio" aria-checked={true} className="relative w-full text-left rounded-2xl border-2 p-4 sm:p-6 transition-shadow duration-200 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 focus:ring-offset-teal-50 border-brand-500 bg-white shadow-[0_22px_50px_-20px_rgba(6,182,212,0.65),0_0_0_7px_rgba(6,182,212,0.09)]" data-id="element-160" data-mp="cn02mdh3704h">
            <div className="flex items-start gap-3" data-id="element-161" data-mp="3p3n7fmsrvsey">
              {/* Radio */}
              <span className="mt-1 shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors border-brand-400 bg-brand-500" aria-hidden="true" data-id="element-162" data-mp="3hkm71ad9qevt">
                <span className="w-2 h-2 rounded-full bg-white" data-id="element-163" data-mp="38j605clnwuwc"></span>
              </span>

              {/* Left content */}
              <div className="min-w-0 flex-1" data-id="element-164" data-mp="2ymt5ociamd0j">
                <h3 className="font-black text-navy text-[15px] sm:text-lg flex items-start gap-1.5 leading-tight tracking-tight" data-id="element-165" data-mp="2ynl3ltzd4mtz">
                  <span className="shrink-0 text-lg sm:text-xl leading-none" data-id="element-166" data-mp="2tu039vaargrm">
                    🧩
                  </span>
                  <span data-id="element-167" data-mp="2kvoe7xp2wr1a">KIT DE CONDUCTA INFANTIL</span>
                </h3>
                <p className="text-teal-600 text-[13px] font-bold mt-1" data-id="element-168" data-mp="2ktbpn1otfif9">
                  3 Tomos + 5 Bonos
                </p>
                <span className="inline-block mt-2 bg-navy text-white text-[9px] font-bold uppercase tracking-[0.15em] px-2 py-1 rounded-full" data-id="element-169" data-mp="2axiftq2he316">
                  Oferta de lanzamiento
                </span>
                <p className="text-ink-muted text-[11px] sm:text-xs mt-2 leading-snug" data-id="element-170" data-mp="2698xaydjliqk">
                  Sabé qué hacer frente a rabietas, desobediencia y límites
                  difíciles, sin terminar perdiendo la paciencia.
                </p>
                <p className="text-[11px] font-bold mt-2 text-emerald-600" data-id="element-171" data-mp="1was1no3nsfy6">
                  ✓ Pago único
                </p>
              </div>

              {/* Right price column */}
              <div className="shrink-0 text-right pl-1" data-id="element-172" data-mp="2oynxkqlem3tw">
                <p className="text-ink-soft line-through text-xs leading-none" data-id="element-173" data-mp="2aauid708d3bu">
                  USD 49.99
                </p>
                <p className="text-[26px] sm:text-4xl font-black text-navy leading-none tracking-tight mt-1" data-id="element-174" data-mp="2f830j7ldp7d3">
                  USD 19.99
                </p>
                <span className="inline-block mt-2 bg-teal-500 text-white text-[10px] font-bold uppercase tracking-wide px-2 py-1 rounded-full" data-id="element-175" data-mp="37pf29eug561y">
                  Ahorrás USD 30
                </span>
              </div>
            </div>
          </button>
        </div>

        {/* Single main CTA */}
        <div className="max-w-2xl mx-auto mt-6" data-id="element-176" data-mp="1609gtg1tniew">
          <Button className="w-full text-base py-4 shadow-[0_0_20px_rgba(6,182,212,0.4)]" onClick={() => {
            trackInitiateCheckout();
            window.location.href = CHECKOUT_URL;
          }} data-id="element-177" data-mp="15zzrzvsijhas">
            → QUIERO MI KIT POR USD 19.99
          </Button>
          <p className="text-center text-xs text-ink-soft mt-3" data-id="element-178" data-mp="8ellkyh3r64y">
            Garantía 7 días · Pago seguro · Acceso inmediato · 100% digital
          </p>
          </div>
        </div>
      </section>
    </>;
}